import { render, staticRenderFns } from "./LimitQuestion.vue?vue&type=template&id=023583cb&scoped=true"
import script from "./LimitQuestion.vue?vue&type=script&lang=js"
export * from "./LimitQuestion.vue?vue&type=script&lang=js"
import style0 from "./LimitQuestion.vue?vue&type=style&index=0&id=023583cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023583cb",
  null
  
)

export default component.exports